
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
import ButtonSmall from './ButtonSmall.js'
export default class RoundSummary extends PIXI.Container {
    constructor(...arg) {
        super(...arg);
        this.title = "Match Summary"
        this.round = 1;
        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));


        //popupBackground
        var popupBackground = new PIXI.Graphics();
        popupBackground.beginFill(0x000000);
        popupBackground.drawRect(-500, -500, 1000, 1000);
        popupBackground.alpha = 0.1;
        this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);




        // this.color = color|| 0x479ACE;// or 0x479ACE or 0xC03500
        this.color = 0x479ACE;// or 0x479ACE or 0xC03500
        //titleBox
        var titleBox = new PIXI.Graphics();
        titleBox.beginFill(this.color);
        titleBox.drawRoundedRect(0, 0, 500, 80, 10);
        // titleBox.beginFill(0x333333);
        // titleBox.drawRoundedRect(0, 400, 550, 80, 10);
        this.container.addChild(titleBox);


        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.drawRect(0, 50, 500, 350);
        this.container.addChild(graphics);



        //   //backgroundTitle
        //   var backgroundTitle = new PIXI.Graphics();
        //   backgroundTitle.beginFill(0x333333);
        //   backgroundTitle.lineStyle(2, 0xFFFFFF, 1);
        //   // graphics.drawRect(0, 0, 250, 60);
        //   backgroundTitle.drawRoundedRect(100, -50, 300, 60, 10);
        //   //backgroundTitle.alpha = 0.9;
        //   this.container.addChild(backgroundTitle);


        //   //textTitle
        // this.textTitle = new PIXI.Text('Round 3', styleTitle);
        // this.textTitle.x = 250;
        // this.textTitle.y = -40;
        // this.textTitle.anchor.set(0.5, 0);
        // this.textTitle.scale.set(0.5);
        // this.container.addChild(this.textTitle);


        let styleTitle = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 30 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });

        //textTitle
        this.textTitle = new PIXI.Text(this.title, styleTitle);
        this.textTitle.x = 250;
        this.textTitle.y = 7;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

        //textHeader1
        this.textHeader1 = new PIXI.Text('', styleNormal);
        this.textHeader1.x = 20;
        this.textHeader1.y = 70;
        this.textHeader1.scale.set(0.5);
        this.container.addChild(this.textHeader1);

        //textHeader2
        this.textHeader2 = new PIXI.Text('Play', styleNormal);
        this.textHeader2.x = 155;
        this.textHeader2.y = 70;
        this.textHeader2.scale.set(0.5);
        this.container.addChild(this.textHeader2);

        //textHeader3
        this.textHeader3 = new PIXI.Text('Hand', styleNormal);
        this.textHeader3.x = 235;
        this.textHeader3.y = 70;
        this.textHeader3.scale.set(0.5);
        this.container.addChild(this.textHeader3);

        //textHeader4
        this.textHeader4 = new PIXI.Text('Crib', styleNormal);
        this.textHeader4.x = 315;
        this.textHeader4.y = 70;
        this.textHeader4.scale.set(0.5);
        this.container.addChild(this.textHeader4);

        //textHeader5
        this.textHeader5 = new PIXI.Text('Total', styleNormal);
        this.textHeader5.x = 390;
        this.textHeader5.y = 70;
        this.textHeader5.scale.set(0.5);
        this.container.addChild(this.textHeader5);

        //textRow1Col1
        this.textRow1Col1 = new PIXI.Text('You', styleNormal);
        this.textRow1Col1.x = 20;
        this.textRow1Col1.y = 115;
        this.textRow1Col1.scale.set(0.5);
        this.container.addChild(this.textRow1Col1);

        //textRow1Col1
        this.textRow1Col2 = new PIXI.Text('5', styleNormal);
        this.textRow1Col2.x = 155;
        this.textRow1Col2.y = 115;
        this.textRow1Col2.scale.set(0.5);
        this.container.addChild(this.textRow1Col2);

        //textRow1Col3
        this.textRow1Col3 = new PIXI.Text('16', styleNormal);
        this.textRow1Col3.x = 235;
        this.textRow1Col3.y = 115;
        this.textRow1Col3.scale.set(0.5);
        this.container.addChild(this.textRow1Col3);

        //textRow1Col4
        this.textRow1Col4 = new PIXI.Text('45', styleNormal);
        this.textRow1Col4.x = 315;
        this.textRow1Col4.y = 115;
        this.textRow1Col4.scale.set(0.5);
        this.container.addChild(this.textRow1Col4);

        //textRow1Col5
        this.textRow1Col5 = new PIXI.Text('60', styleLarge);
        this.textRow1Col5.x = 390;
        this.textRow1Col5.y = 115 - 6;
        this.textRow1Col5.scale.set(0.5);
        this.container.addChild(this.textRow1Col5);


        //textRow2Col1
        this.textRow2Col1 = new PIXI.Text('Computer', styleNormal);
        this.textRow2Col1.x = 20;
        this.textRow2Col1.y = 160;
        this.textRow2Col1.scale.set(0.5);
        this.container.addChild(this.textRow2Col1);

        //textRow2Col1
        this.textRow2Col2 = new PIXI.Text('23', styleNormal);
        this.textRow2Col2.x = 155;
        this.textRow2Col2.y = 160;
        this.textRow2Col2.scale.set(0.5);
        this.container.addChild(this.textRow2Col2);

        //textRow2Col3
        this.textRow2Col3 = new PIXI.Text('4', styleNormal);
        this.textRow2Col3.x = 235;
        this.textRow2Col3.y = 160;
        this.textRow2Col3.scale.set(0.5);
        this.container.addChild(this.textRow2Col3);

        //textRow2Col4
        this.textRow2Col4 = new PIXI.Text('0', styleNormal);
        this.textRow2Col4.x = 315;
        this.textRow2Col4.y = 160;
        this.textRow2Col4.scale.set(0.5);
        this.container.addChild(this.textRow2Col4);

        //textRow2Col5
        this.textRow2Col5 = new PIXI.Text('24', styleLarge);
        this.textRow2Col5.x = 390;
        this.textRow2Col5.y = 160 - 6;
        this.textRow2Col5.scale.set(0.5);
        this.container.addChild(this.textRow2Col5);


        // //background
        // var graphics = new PIXI.Graphics();
        // graphics.beginFill(0xCCCCCC);
        // graphics.lineStyle(0, 0x222222, 1);
        // // graphics.drawRect(0, 0, 500, 500);
        // graphics.drawRoundedRect(10, 280, 430, 80, 10);
        // this.container.addChild(graphics);


        // //line background
        // var line = new PIXI.Graphics();
        // line.lineStyle(2, 0xFFFFFF, 2);
        // line.moveTo(10, 280);
        // line.lineTo(470, 280);
        // this.container.addChild(line);

        // //textHeader1
        // this.textAnalyzeSummary = new PIXI.Text('Optimal discard score: 0.70', styleNormal);
        // this.textAnalyzeSummary.x = 20;
        // this.textAnalyzeSummary.y = 295;
        // this.textAnalyzeSummary.scale.set(0.5);
        // this.container.addChild(this.textAnalyzeSummary);


        // //Analyze Round  button
        // this.btnAnalyze = new ButtonSmall("...", 0x444444, 100);
        // this.btnAnalyze.x = 480 - (10 + 100);
        // this.btnAnalyze.y = 290;
        // this.btnAnalyze.interactive = true;
        // this.btnAnalyze.on('pointerdown', this.btnAnalyze_onClick.bind(this));
        // this.container.addChild(this.btnAnalyze);


        //textTapToContinue
        this.textTapToContinue = new PIXI.Text('Tap to continue', styleSmall);
        this.textTapToContinue.x = 250;
        this.textTapToContinue.y = 385;
        this.textTapToContinue.anchor.set(0.5, 0);
        this.textTapToContinue.scale.set(0.5);
        this.container.addChild(this.textTapToContinue);


        //center content
        this.container.x = 0 - (this.container.width / 2);
        this.container.y = 0 - (this.container.height / 2);
    }

    updateScore(scoreSummary) {
        this.round = scoreSummary.round;
        if (!scoreSummary.hasOwnProperty('player1')) scoreSummary["player1"] = {};
        if (!scoreSummary.hasOwnProperty('player2')) scoreSummary["player1"] = {};

        this.textRow1Col1.text = scoreSummary["player1"].name || "You";
        // textRow2Col2.text = scoreSummary["player1"].starter|| 0;
        this.textRow1Col2.text = (scoreSummary["player1"].play || 0) + (scoreSummary["player1"].starter || 0);
        this.textRow1Col3.text = scoreSummary["player1"].hand || 0;
        this.textRow1Col4.text = scoreSummary["player1"].crib || 0;
        this.textRow1Col5.text = scoreSummary["player1"].total || 0;

        this.textRow2Col1.text = scoreSummary["player2"].name || "Computer";
        // textRow2Col2.text = scoreSummary["player1"].starter|| 0;
        this.textRow2Col2.text = (scoreSummary["player2"].play || 0) + (scoreSummary["player2"].starter || 0);
        this.textRow2Col3.text = scoreSummary["player2"].hand || 0;
        this.textRow2Col4.text = scoreSummary["player2"].crib || 0;
        this.textRow2Col5.text = scoreSummary["player2"].total || 0;

        //this.textAnalyzeSummary.text = 'Optimal discard score: ' + (this.analyzeSummary || 0);
    }
    btnExplain_onClick(event) {
        if (this.onExplain) {
            this.onExplain(this.round);
        }
        event.stopPropagation();
    }
    btnNext_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        this.visible = false;
        this.parent.isDirty = true;
        // this.parent.isDirty = true;
        // this.parent.removeChild(this);
        event.stopPropagation();
    }
    btnAnalyze_onClick(event) {
        if (this.onAnalyze) {
            this.onAnalyze(this.round);
        }
        event.stopPropagation();
    }
    close_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        this.parent.isDirty = true;
        this.parent.removeChild(this);
        event.stopPropagation();
    }
}